import classNames from 'classnames'
import { ReactNode } from 'react'

interface IProps {
  classes?: string
  children: ReactNode
}

export const PageSubtitle = ({ classes, children }: IProps) => (
  <div className={classNames('jost-light text-[1.05rem] sm:text-[1.35rem]', classes)}>{children}</div>
)
